import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";

export class UpdateExcludedFilesCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly frontend,
  ) { }

  async run(load_path_id:string, excluded_files, excluded_date): Promise<any> {
    let args = { 
      load_path_id: load_path_id,
      excluded_files: excluded_files,
      excluded_date: excluded_date
    }   
    await this.dispatcher.dispatch('update_excluded_files', args)    
  }
}